import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { DocumentationHelpButtonComponent } from '@common/documentation/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let DocumentationFrontendAdminFeature = /*#__PURE__*/(() => {
  let DocumentationFrontendAdminFeature = class DocumentationFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/documentation/frontend-admin","featureId":"common-documentation"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineWidgets([{
        type: 'Content',
        id: 'DocumentationHelpButtonComponent',
        positionIds: ['app-toolbar-right'],
        component: DocumentationHelpButtonComponent
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵDocumentationFrontendAdminFeature_BaseFactory;
        return function DocumentationFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵDocumentationFrontendAdminFeature_BaseFactory || (ɵDocumentationFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(DocumentationFrontendAdminFeature)))(__ngFactoryType__ || DocumentationFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: DocumentationFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  };
  DocumentationFrontendAdminFeature = __decorate([ClassName("DocumentationFrontendAdminFeature")], DocumentationFrontendAdminFeature);
  return DocumentationFrontendAdminFeature;
})();
export { DocumentationFrontendAdminFeature };